<template>
  <div class="mainWeb">
    <el-dialog title="阈值设置"  :visible.sync="showyuzhi" width="1000px">
      <div style="margin-bottom:20px;">私教课名称：{{yuzhiObj.courseName}}</div>
      <el-form :model="formparamsYuzhi" :rules="rules" ref="formparamsYuzhi" label-width="110px">
        <el-form-item label="提前提醒剩余次数" prop="minvalue">
          <el-input class="w220" v-model.number="formparamsYuzhi.minvalue" placeholder="请输入提前提醒次数"></el-input>
        </el-form-item>
        <el-form-item label="过期提前提醒天数" prop="expireMinValue">
          <el-input class="w220" v-model.number="formparamsYuzhi.expireMinValue" placeholder="请输入过期提前提醒天数"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button style="width:100px"  @click="resetFormYuzhi('formparamsYuzhi')">取 消</el-button>
          <el-button style="width:100px"  type="primary" @click="submitFormYuzhi('formparamsYuzhi')">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="私教信息"  :visible.sync="dialogVisible" width="1000px">
      <el-form :model="formparams" :rules="rules" ref="formparams" label-width="100px">
        <el-form-item label="私教课价格" prop="actualPrice">
          <el-input class="w220" v-model="formparams.actualPrice" placeholder="请输入私教课价格"></el-input>
        </el-form-item>
        
        <el-form-item label="任课教练" prop="jid">
          <el-select v-model="formparams.jid" placeholder="请选择">
            <el-option v-for="item in this.optionsJL"
            :key="item.id"
            :label="item.name"
            :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="上课时常" prop="teachTime">
          <el-input v-model.number="formparams.teachTime" placeholder="请输入上课时常" maxlength="20"></el-input>
        </el-form-item> -->
        <el-form-item label="上课教室">
          <el-select v-model="formparams.classRoom" placeholder="请选择">
            <el-option v-for="item in this.roomList"
            :key="item.id"
            :label="item.name"
            :value="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="私教课类型" prop="mode">
          <el-input class="w220" v-model.number="formparams.mode" placeholder="私教课类型（1V2/1V3 传1、2、3、4）" maxlength="20"></el-input>
        </el-form-item>
        <el-row>
          <el-col :span="8">
            <el-form-item label="是否可选择购买数量" label-width="140px">
              <el-switch
                v-model="formparams.changeVariable"
                active-value= '1'
                inactive-value= '0'
                active-text="是"
                inactive-text="否">
              </el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="是否可减少" label-width="140px" v-if="formparams.changeVariable=='1'">
              <el-switch
                v-model="formparams.minus"
                active-value= '1'
                inactive-value= '0'
                active-text="是"
                inactive-text="否">
              </el-switch>
            </el-form-item>
          </el-col>
            <el-col :span="8">
            <el-form-item label="是否可增加" label-width="140px" v-if="formparams.changeVariable=='1'">
              <el-switch
                v-model="formparams.addUp"
                active-value= '1'
                inactive-value= '0'
                active-text="是"
                inactive-text="否">
              </el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="一次购买节数" label-width="120px">
          <el-input class="w220" v-model="formparams.limitNum" placeholder="请输入一次购买节数"></el-input>
        </el-form-item>
        <el-form-item label="提前可预约天数" label-width="120px">
          <el-input class="w220" v-model="formparams.appointmenttime" placeholder="请输入提前可预约天数"></el-input>
        </el-form-item>
        <el-form-item label="取消预约时间类型" label-width="130px">
          <el-select v-model="formparams.cancleTimeType" clearable placeholder="请选择">
            <el-option v-for="item in this.timetypes2"
            :key="item.value"
            :label="item.lable"
            :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="取消预约时长">
          <el-input class="w220" v-model="formparams.canceltime" placeholder="请输入取消预约时长"></el-input>
        </el-form-item>
        <el-form-item label="课程说明" prop="courseDetails">
          <editor-bar v-model="formparams.courseDetails" :isClear="isClear"></editor-bar>
          <!-- <el-input type="textarea" rows="4"  v-model="formparams.courseDetails" placeholder="请输入卡说明"></el-input> -->
        </el-form-item>
      </el-form> 
      <span slot="footer" class="dialog-footer">
          <el-button style="width:100px"  @click="resetForm('formparams')">取 消</el-button>
          <el-button style="width:100px"  type="primary" @click="submitForm('formparams')">确 定</el-button>
      </span>
    </el-dialog>
    <el-row class="tableList">
      <el-table v-loading="loading" :data="tableDataOn" height="68vh" border stripe>
        <el-table-column
          label="序号"
          type="index"
          width="50">
        </el-table-column>
        <el-table-column prop="infI.name" label="私教课程名"></el-table-column>
        <el-table-column label="分店">
          <template slot-scope="scope">
            <div>{{scope.row.shopNum|changeType}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="infE.name" label="教练名"></el-table-column>
        <!-- <el-table-column prop="courseStartTime" label="课程开始时间"></el-table-column>
        <el-table-column prop="courseEndTime" label="课程结束时间"></el-table-column> -->
        <!-- <el-table-column label="上课时长">
          <template slot-scope="scope">
            <span>{{scope.row.teachTime}}分钟</span>
          </template>
        </el-table-column> -->
        <el-table-column prop="actualPrice" label="价格"></el-table-column>
        <el-table-column prop="classRoom" label="教室"></el-table-column>
        <!-- <el-table-column label="私教图片" width="120">
          <template slot-scope="scope">
            <img style="width:100px;height:100px" :src="'http://zlesp.zlydgy.cn:8091/images/'+ scope.row.imgurl" alt="">
          </template>
        </el-table-column> -->
        <el-table-column label="私教课类型">
          <template slot-scope="scope">
            <span>1v{{scope.row.mode}}</span>
          </template>
        </el-table-column>
        <el-table-column label="私教课说明">
          <template slot-scope="scope">
            <el-popover trigger="hover" placement="top" width="300px">
              <p style="width:300px;" v-html="scope.row.courseDetails"></p>
              <div slot="reference" class="name-wrapper">
                <el-tag size="medium">鼠标放上查看详情</el-tag>
              </div>
            </el-popover>
            </template>
        </el-table-column>
        <el-table-column width="240" label="操作">
          <template slot-scope="scope">
            <el-button style="width:100px"  type="primary" @click="edit(scope.row)">编辑</el-button>
            <!-- <el-button style="width:100px"  type="primary" @click="setThreshold(scope.row)">阈值设置</el-button> -->
            <el-button style="width:100px"  type="danger" v-show="scope.row.isWeb==1" @click="removeList(scope.row,0)">下架</el-button>
            <el-button style="width:100px"  type="success" v-show="scope.row.isWeb==0" @click="removeList(scope.row,1)">上架</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
  </div>
</template>

<script>
import {getPtClass, getClassRoom, getCardsSell, getShops,getVieWEJt, updateCardsSell, deleteTbPrivateCourse,getInfI,getThreshold,setThreshold} from "../../api/configApi";
// import onlineCard from './onlineCard'
import EditorBar from '../../components/wangEnduit'
let that;
export default {
  props:["tableDataOn","queryParams","shopListNew"],
  data() {
    return {
      activeName:'offLine',
      loading: false,
      dialogVisible: false,
      showyuzhi: false,
      hideUpload:false,
      showQuery: false,
      showShop:false,
      isClear: false,
      name:'',
      yuzhiObj: {
        courseName: '',
      },
      date:[],
      fileList:[],
      roomList:[],
      timetypes2:[
        // {lable:'当天',value:2},
        {lable:'天',value:0},
        {lable:'小时',value:1},
        {lable:'分钟',value:2}
      ],
      rules:{
        appointmenttime:[
          { required: true, message: '请输入提前预约时长', trigger: 'blur' }
        ],
        timetype:[
          { required: true, message: '请选择时间类型', trigger: 'change' }
        ],
        canceltime:[
          { required: true, message: '请输入取消预约时长', trigger: 'blur' }
        ],
        minvalue: [
          { required: true, message: '请输入阈值', trigger: 'blur' },
        ],
        expireMinValue: [
          { required: true, message: '请输入阈值', trigger: 'blur' },
        ],
        actualPrice: [
          { required: true, message: '请输入金额', trigger: 'blur' },
          { pattern:/^(([0-9]|([1-9][0-9]{0,9}))((\.[0-9]{1,2})?))$/, message: '请输入正确金额', trigger: 'blur' }
        ],
        jid:[
          { required: true, message: '请选择教练', trigger: 'change' }
        ],
        // classRoom:[
        //   { required: true, message: '请选择教室', trigger: 'change' }
        // ],
        description:[{ required:true,message:'请输入票说明',trigger:'blur' }],
        
        // teachTime:[
        //   { required: true, message: '请输入上课时长'},
        //   { type: 'number', message: '必选为数字'}
        // ],
        mode:[
          { required: true, message: '请输入私教课类型'},
          { type: 'number', message: '必选为数字'}
        ],
        date: [
          {
            type: "array",
            required: true,
            trigger: "blur",
            validator: (rule, value, callback) => {
              if (this.date[0] != "") {
                callback();
              } else {
                callback(new Error("请选择日期"));
              }
            }
          }
        ]
      },
      optionsJL:[],//教练列表
      formparams:{
        // courseStartTime:'',//开课时间
        // courseEndTime:'',//结束时间
        actualPrice:'',//价格
        jid:'',//教练id
        iid:'',//项目id
        iShortName:'',//项目简称
        // teachTime:'',//上课时常
        shopNum:'',//分店编号
        courseDetails:'',//上课说明
        classRoom:'',//上课教室
        mode:'',//私教课类型
        appointmenttime: '',//提前可预约天数
        timetype: '0', //时间类型
        canceltime: '', //多长时间取消
        cancleTimeType: '',//取消时间类型
        changeVariable: '1', //购买数量是否可选择
        minus: '1',
        addUp: '1',
        limitNum: null
      },
      formparamsYuzhi: {
        minvalue: '',
        expireMinValue: '',
        shortName: '',
        shopNum: ''
      },
      tableData:[],
      tableDataOff:[],
      //分店列表
      shopList:[],
      shopListAll:JSON.parse(sessionStorage.getItem('shopListAll')),
      total: 0,
      currentPage: 1,
      params: {
        shopNum:null,
        name:null,
        pageNo: 1,
        pageSize: 20
      }
    }
  },
  components:{
    EditorBar,
  },
  beforeCreate(){
    that = this
  },
  created(){
  },
  mounted() {
  },
  filters:{
    changeType(value){
      if (that.shopListAll.find(i => {
        return i.shopNum == value
        })) {
        return that.shopListAll.find(i => {
            return i.shopNum == value
        }).name
      }
    }
  },
  methods: {
    //查询教练
    getVieWEJt(shopNum){
      getVieWEJt({shopNum:shopNum}).then((res)=>{
        console.log(res)
        if(res.msg=='success'){
          this.optionsJL = res.data
          sessionStorage.setItem('optionsJL',JSON.stringify(res.data))
        }else {
          this.$message.error(res.data)
        }
      })
    },
    getClassRoom(shopNum){
      getClassRoom({shopNum:shopNum,type:1}).then((res)=>{
        if(res.msg == 'success'){
          this.roomList = res.data
        }
      })
    },
    getTableList(){
      this.params.shopNum = this.queryParams.shopNum
      this.params.name = this.queryParams.name
      getPtClass(this.params).then((res)=>{
        if(res.msg=='success'){
          // this.tableDataOn = res.data.info
           this.$emit('getTableDataOn',res.data)
          this.total = res.data.total
          // console.log(this.tableData)       
        }else {
          this.$message.error(res.data)
        }
        this.loading = false
      })
    },
    edit(row){
      this.dialogVisible = true
      this.formparams.actualPrice = row.actualPrice
      this.formparams.courseDetails = row.courseDetails
      this.formparams.classRoom = row.classRoom
      this.formparams.mode = row.mode
      // this.formparams.timetype = row.timetype
      if(row.changeVariable){
        this.formparams.changeVariable = row.changeVariable //购买数量是否可选择
      }else {
        this.formparams.changeVariable = '1'
      }
      if(row.minus){
        this.formparams.minus = row.minus
      }else {
        this.formparams.minus = '1'
      }
      if(row.addUp){
        this.formparams.addUp = row.addUp
      }else {
        this.formparams.addUp = '1'
      }
      if(row.limitNum){
        this.formparams.limitNum = row.limitNum
      }else {
        this.formparams.limitNum = null
      }
      console.log('ok',row,this.formparams)
      this.formparams.id = row.id
      this.formparams.iid = row.iid
      this.formparams.shopNum = row.shopNum
      if(row.tbAppointConfig) {
        this.formparams.appointmenttime = row.tbAppointConfig.appointmenttime //提前可预约天数
        this.formparams.canceltime = row.tbAppointConfig.canceltime //多长时间取消
        this.formparams.cancleTimeType = row.tbAppointConfig.cancleTimeType //取消时间类型
      }

      this.getClassRoom(row.shopNum)
      this.formparams.iShortName = row.infI.shortname
      if(this.fileList){
        this.hideUpload = true
      } else{
        this.hideUpload = false
      }
      this.fileList=[]
      this.fileList.push({url:'http://zlesp.zlydgy.cn:8091/images/'+row.imgurl})
      this.getVieWEJt( row.shopNum )
      this.formparams.jid = row.jid
    },
    setThreshold(row) {
      this.yuzhiObj.courseName = row.infI.name
      this.formparamsYuzhi.shortName = row.infI.shortname
      this.getThreshold(row.shopNum,row.infI.shortname,'0')
      this.showyuzhi = true
    },
    // 查看项目阈值
    getThreshold(shopNum,shortName,type) {
      this.formparamsYuzhi.shopNum = shopNum
      getThreshold({shopNum:shopNum,shortName:shortName,type:type}).then(res=>{
        if(res.msg == 'success'){
          if(res.data.minvalue) {
            this.formparamsYuzhi.minvalue = res.data.minvalue
          }
          if(res.data.expireMinValue) {
            this.formparamsYuzhi.expireMinValue = res.data.expireMinValue
          }
        }else{
          this.$message.error(res.data)
        }
      })
    },
    removeList(row,isWeb){
      let str = ''
      if(isWeb==0) {
        str = '下架'
      }else {
        str = '上架'
      }
        this.$confirm('您确定要'+str+'此课程吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          deleteTbPrivateCourse({id:row.id,iShortName:row.infI.shortname,isWeb}).then(res=>{
            if(res.msg == 'success'){
              this.$message({
                type:'success',
                message: str+'成功'
              })
              this.getTableList()
            }else{
              this.$message.error(res.data);
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'+ str
          });          
        });
    },

    handleRemove(fileList) {
      this.hideUpload = fileList.length >= this.fileList.length;
    },
    onChange(file, fileList){
      this.hideUpload = fileList.length >= this.fileList.length;
    },
    uploadFile(file){
      this.formData.append('uploadFile', file.file);
    },
    submitForm(formparams){
      this.$refs[formparams].validate(valid => {
        if (valid) {
          this.formData = new FormData()
          this.formData.append('id', this.formparams.id);
          this.formData.append('actualPrice', this.formparams.actualPrice);
          this.formData.append('jid', this.formparams.jid);
          this.formData.append('iid', this.formparams.iid);
          this.formData.append('iShortName', this.formparams.iShortName);
          this.formData.append('shopNum', this.formparams.shopNum);
          this.formData.append('courseDetails', this.formparams.courseDetails);
          this.formData.append('classRoom', this.formparams.classRoom);
          this.formData.append('mode', this.formparams.mode);
          this.formData.append('limitNum', this.formparams.limitNum);
          this.formData.append('changeVariable', this.formparams.changeVariable);

          this.formData.append('appointmenttime', this.formparams.appointmenttime);
          this.formData.append('cancleTimeType', this.formparams.cancleTimeType);
          this.formData.append('canceltime', this.formparams.canceltime);
          this.formData.append('timetype', this.formparams.timetype);
          if(this.formparams.changeVariable=='1') {
            this.formData.append('minus', this.formparams.minus);
            this.formData.append('addUp', this.formparams.addUp);
          }else {
            this.formData.append('minus', '0');
            this.formData.append('addUp', '0');
          }
          let config = {
              headers: {
                'Content-Type':'multipart/form-data',
                'token':sessionStorage.getItem('token')
              }
          }
          this.$http.post('ptClass/updateTbPrivateCourse', this.formData, config).then((res)=>{
            console.log(res)
            if(res.data.msg == 'success'){
              this.dialogVisible = false
              this.$message({
                type:'success',
                message:'添加成功'
              })
            }
            this.params.pageNo = this.queryParams.pageNo
            this.params.pageSize = this.queryParams.pageSize
            this.getTableList()
          })
        }
      });
    },
    submitFormYuzhi(formparamsYuzhi) {
      this.$refs[formparamsYuzhi].validate(valid => {
        if (valid) {
          setThreshold({minvalue:this.formparamsYuzhi.minvalue,expireMinValue:this.formparamsYuzhi.expireMinValue,shortName:this.formparamsYuzhi.shortName,shopNum:this.formparamsYuzhi.shopNum,type:0}).then(res=>{
            if(res.msg == 'success'){
              this.$message({
                type:'success',
                message:'设置成功'
              })
              this.formparamsYuzhi.minvalue = ''
              this.formparamsYuzhi.expireMinValue = ''
              this.resetFormYuzhi(this.formparamsYuzhi)
            }else{
              this.$message.error(res.data)
            }
          })
        }
      });
    },
    //取消
    resetForm(formparams) {
      this.dialogVisible = false;
      if(this.$refs[formparams]!=undefined){
        this.$refs[formparams].clearValidate();
      }
    },
    //取消
    resetFormYuzhi(formparamsYuzhi) {
      this.showyuzhi = false;
      if(this.$refs[formparamsYuzhi]!=undefined){
        this.$refs[formparamsYuzhi].clearValidate();
      }
    },
  }
}
</script>
<style scoped lang="scss">
.tableList {
  width: 100%;
  margin-top: 20px;
  /* height: 73vh; */
  overflow-y: auto;
  padding: 20px;
  background: #ffffff;
  box-shadow: none;
  border-radius: 5px;
}
</style>


// WEBPACK FOOTER //
// onlineCoach.vue?9ff756c0